import {CustomercfgQuotaFeaturesApp} from "./CustomerTypes";
import {CustomercfgView} from "../subaccount/CustomercfgView";
import {AppPlatformTypeId} from "../apps/AppPlatformType";

export function hasAnyAppAccess(quotaFeaturesApp: CustomercfgQuotaFeaturesApp): boolean {
    quotaFeaturesApp.appCfgLimit
    return (quotaFeaturesApp.appCfgLimit == null || quotaFeaturesApp.appCfgLimit > 0) && (
        quotaFeaturesApp.allowWeb ||
        quotaFeaturesApp.allowRoku ||
        quotaFeaturesApp.allowAndroid ||
        quotaFeaturesApp.allowIos ||
        quotaFeaturesApp.allowAndroidtv ||
        quotaFeaturesApp.allowAppletv ||
        quotaFeaturesApp.allowFiretv
    )
}

export function getAppLimit(quotaFeaturesApp: CustomercfgQuotaFeaturesApp | undefined | null): number {
    return quotaFeaturesApp?.appCfgLimit ?? (quotaFeaturesApp ? Number.MAX_SAFE_INTEGER : 0);
}


export function isAppPlatformAllowed(quotaFeaturesApp: CustomercfgQuotaFeaturesApp, id: AppPlatformTypeId): boolean {
    switch (id) {
        case AppPlatformTypeId.Web:
            return quotaFeaturesApp.allowWeb;
        case AppPlatformTypeId.Roku:
            return quotaFeaturesApp.allowRoku;
        case AppPlatformTypeId.Firetv:
            return quotaFeaturesApp.allowFiretv;
        case AppPlatformTypeId.Appletv:
            return quotaFeaturesApp.allowAppletv;
        case AppPlatformTypeId.Androidtv:
            return quotaFeaturesApp.allowAndroidtv;
        case AppPlatformTypeId.Android:
            return quotaFeaturesApp.allowAndroid;
        case AppPlatformTypeId.Ios:
            return quotaFeaturesApp.allowIos;
        default:
            return false;
    }
}

